import { FC } from "react"
import AddActionAction from "./AddAction.action"
import { NodeDefinition, NodeDefinitionCategoryEnum } from "@/gen"


//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
// export enum DefaultActionTypeId {
//   ADD_ACTION = "add-action",
//   TRIGGER = "trigger",

//   // CORE
//   // AWAIT = "await",
// }

export const defaultScenarioActions: (NodeDefinition & { drawer: any })[] = [
  {
    type: "add-action",
    color: "gray",
    label: "Add Action",
    description: "Add an action to your scenario",
    image_src: "",
    drawer: AddActionAction,
    category: NodeDefinitionCategoryEnum.internal,
  },
  // {
  //   id: DefaultActionTypeId.TRIGGER,
  //   color: "#10b981",
  //   description: "Triggers start your workflow. Workflows can have multiple triggers.",
  //   label: "Trigger",
  //   iconElement: IconIconParkSolidClick,
  //   // drawer: AddActionAction,
  //   category: ActionCategory.TRIGGER,
  // },

  // Core
  // ...awaitAction,
]

// ██████╗ ███████╗███████╗
// ██╔══██╗██╔════╝██╔════╝
// ██║  ██║█████╗  █████╗
// ██║  ██║██╔══╝  ██╔══╝
// ██████╔╝███████╗██║
// ╚═════╝ ╚══════╝╚═╝
//
// export const ActionsDef = {
//   enum: ActionTypeId,
//   list: scenarioActions,
//   record: scenarioActions.reduce(
//     (acc, item) => {
//       acc[item.id] = item
//       return acc
//     },
//     {} as Record<ActionTypeId, ActionTypeDef<any>>,
//   ),
// }
